import { useTranslation } from 'react-i18next'
import { runtimeConfig } from '@/runtime-config'

export const LINK_PLACEHOLDER = '{{link}}'

const CONFIRMATION_LINK_LENGTH = `${runtimeConfig.BROWSERY_URL}/api/opt-in-confirm/`.length + 40

export const smsLength = (value: string) => {
  if (value.includes(LINK_PLACEHOLDER)) {
    return value.length - LINK_PLACEHOLDER.length + CONFIRMATION_LINK_LENGTH
  }

  return value.trimEnd().length + 2 + CONFIRMATION_LINK_LENGTH
}

const useOptInSmsTextField = (value: string) => {
  const { t } = useTranslation()

  return {
    label: t('common:opt_in_sms.label'),
    caption: t('common:opt_in_sms.caption', { count: smsLength(value), link: LINK_PLACEHOLDER }),
    placeholder: t('common:opt_in_sms.placeholder', { link: LINK_PLACEHOLDER }),
  }
}

export default useOptInSmsTextField
